import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AdminLayout() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <Box sx={{ display: "flex", minHeight: "100vh" }}>
            {/* SIDEBAR: fixo no desktop, drawer no mobile */}
            <Sidebar
                open={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                isMobile={isMobile}
            />

            {/* CONTEÚDO PRINCIPAL */}
            <Box
                sx={{
                    flexGrow: 1,
                    background: "#f5f6fa",
                    minWidth: 0,
                    marginLeft: isMobile ? 0 : "260px",
                }}
            >
                <Topbar
                    isMobile={isMobile}
                    onMenuClick={() => setSidebarOpen(true)}
                />
                <Box sx={{ p: { xs: 2, sm: 3 } }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}
